import { useContext, useEffect, useState } from 'react'
import { NavLink, useNavigate } from 'react-router'
import ButtonBars from '../components/ButtonBars'
import useAxiosRequests from '../hooks/useAxiosRequest'
import ExternalRoutes from '../config/ExternalRoutes'
import AuthContext from '../context/AuthContext'
import { Filter } from '../components/Filter'

function CalendarFilter() {
  const months = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre'
  ]
  const [year, setYear] = useState(new Date().getFullYear())
  const handlePrevYear = () => setYear(prev => prev - 1)
  const handleNextYear = () => setYear(prev => prev + 1)
  const { sendRequest } = useAxiosRequests()
  const { userInfo } = useContext(AuthContext)
  const [monthlyCounts, setMonthlyCounts] = useState(Array(12).fill(0))
  const navigate = useNavigate()

  const fetchData = async selectedYear => {
    const startDate = `${selectedYear}-01-01`
    const endDate = `${selectedYear}-12-31`
    try {
      const response = await sendRequest({
        method: 'GET',
        url: ExternalRoutes.document.list_by_user + userInfo?.id,
        config: {
          params: {
            'docDateUpload[after]': startDate,
            'docDateUpload[before]': endDate
          }
        }
      })
      const docs = response.member || []
      const counts = countDocsPerMonth(docs, selectedYear)
      setMonthlyCounts(counts)
    } catch (error) { }
  }

  useEffect(() => {
    fetchData(year)
  }, [year])

  const countDocsPerMonth = (docs, year) => {
    const counts = Array(12).fill(0)
    docs.forEach(doc => {
      const date = new Date(doc.docDateUpload)
      if (date.getFullYear() === year) {
        counts[date.getMonth()]++
      }
    })
    return counts
  }

  const handleFilterByMonth = async (index, month) => {
    const startDate = new Date(year, index, 1)
    const endDate = new Date(year, index + 1, 0, 23, 59, 59)
    navigate('/chest-of-documents', {
      state: {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
      }
    });
  }

  const [show, setShow] = useState(false)
  const handleShow = () => setShow(true)
  const currentMonthIndex = new Date().getMonth();
  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className='kl-header-document-document'>
        <div className='kl-header-coffre'>
          <NavLink to='/history' className='kl-coffre-faclock'>
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z'
                fill='#292D32'
              />
              <path
                d='M15.7096 15.93C15.5796 15.93 15.4496 15.9 15.3296 15.82L12.2296 13.97C11.4596 13.51 10.8896 12.5 10.8896 11.61V7.51001C10.8896 7.10001 11.2296 6.76001 11.6396 6.76001C12.0496 6.76001 12.3896 7.10001 12.3896 7.51001V11.61C12.3896 11.97 12.6896 12.5 12.9996 12.68L16.0996 14.53C16.4596 14.74 16.5696 15.2 16.3596 15.56C16.2096 15.8 15.9596 15.93 15.7096 15.93Z'
                fill='#292D32'
              />
            </svg>
          </NavLink>
          <div className='kl-title-header'>
            <h2>Coffre de docs</h2>
          </div>
          <div className=''>
            <NavLink to='/chest-of-documents' className='kl-calendar-filter'>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M4.1 8.75H19.9C20.6105 8.75 20.9271 8.86455 21.0624 8.96608C21.1419 9.02572 21.25 9.14636 21.25 9.57412V12.4259C21.25 12.8536 21.1419 12.9743 21.0624 13.0339C20.9271 13.1355 20.6105 13.25 19.9 13.25H4.1C3.38945 13.25 3.07295 13.1355 2.93763 13.0339C2.85814 12.9743 2.75 12.8536 2.75 12.4259V9.57412C2.75 9.14636 2.85814 9.02572 2.93763 8.96608C3.07295 8.86455 3.38945 8.75 4.1 8.75Z'
                  stroke='#292D32'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M4.1 15.75H19.9C20.6105 15.75 20.9271 15.8645 21.0624 15.9661C21.1419 16.0257 21.25 16.1464 21.25 16.5741V19.4259C21.25 19.8536 21.1419 19.9743 21.0624 20.0339C20.9271 20.1355 20.6105 20.25 19.9 20.25H4.1C3.38945 20.25 3.07295 20.1355 2.93763 20.0339C2.85814 19.9743 2.75 19.8536 2.75 19.4259V16.5741C2.75 16.1464 2.85814 16.0257 2.93763 15.9661C3.07295 15.8645 3.38945 15.75 4.1 15.75Z'
                  stroke='#292D32'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M4.1 1.75H12.9C13.6105 1.75 13.9271 1.86455 14.0624 1.96608C14.1419 2.02572 14.25 2.14636 14.25 2.57412V5.42588C14.25 5.85364 14.1419 5.97428 14.0624 6.03392C13.9271 6.13545 13.6105 6.25 12.9 6.25H4.1C3.38945 6.25 3.07295 6.13545 2.93763 6.03392C2.85814 5.97428 2.75 5.85364 2.75 5.42588V2.57412C2.75 2.14636 2.85814 2.02572 2.93763 1.96608C3.07295 1.86455 3.38945 1.75 4.1 1.75Z'
                  stroke='#292D32'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </NavLink>

            <button className='kl-filter-docs-button' onClick={handleShow}>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M10.9298 22.75C10.4498 22.75 9.96985 22.63 9.52985 22.39C8.63985 21.89 8.1098 21 8.1098 19.99V14.64C8.1098 14.13 7.77979 13.38 7.46979 12.99L3.6698 9.00003C3.0398 8.37003 2.5498 7.27002 2.5498 6.46002V4.14005C2.5498 2.53005 3.76982 1.27002 5.31982 1.27002H18.6598C20.1898 1.27002 21.4298 2.51004 21.4298 4.04004V6.26004C21.4298 7.31004 20.7998 8.52002 20.1998 9.11002C19.9098 9.40002 19.4298 9.40002 19.1398 9.11002C18.8498 8.82002 18.8498 8.34002 19.1398 8.05002C19.5098 7.68002 19.9298 6.85004 19.9298 6.26004V4.04004C19.9298 3.34004 19.3598 2.77002 18.6598 2.77002H5.31982C4.60982 2.77002 4.0498 3.37005 4.0498 4.14005V6.46002C4.0498 6.83002 4.34981 7.56004 4.73981 7.95004L8.58984 12C9.09984 12.63 9.59979 13.69 9.59979 14.64V19.99C9.59979 20.65 10.0498 20.97 10.2498 21.08C10.6798 21.32 11.1898 21.31 11.5898 21.07L12.9898 20.17C13.2798 20 13.5598 19.45 13.5598 19.08C13.5598 18.67 13.8998 18.33 14.3098 18.33C14.7198 18.33 15.0598 18.67 15.0598 19.08C15.0598 19.98 14.4998 21.01 13.7898 21.44L12.3998 22.34C11.9498 22.61 11.4398 22.75 10.9298 22.75Z'
                  fill='#292D32'
                />
                <path
                  d='M16.0701 17.2701C13.8901 17.2701 12.1201 15.5001 12.1201 13.3201C12.1201 11.1401 13.8901 9.37012 16.0701 9.37012C18.2501 9.37012 20.0201 11.1401 20.0201 13.3201C20.0201 15.5001 18.2501 17.2701 16.0701 17.2701ZM16.0701 10.8701C14.7201 10.8701 13.6201 11.9701 13.6201 13.3201C13.6201 14.6701 14.7201 15.7701 16.0701 15.7701C17.4201 15.7701 18.5201 14.6701 18.5201 13.3201C18.5201 11.9701 17.4201 10.8701 16.0701 10.8701Z'
                  fill='#292D32'
                />
                <path
                  d='M19.8705 17.8701C19.6805 17.8701 19.4905 17.8001 19.3405 17.6501L18.3405 16.6501C18.0505 16.3601 18.0505 15.8801 18.3405 15.5901C18.6305 15.3001 19.1105 15.3001 19.4005 15.5901L20.4005 16.5901C20.6905 16.8801 20.6905 17.3601 20.4005 17.6501C20.2605 17.7901 20.0605 17.8701 19.8705 17.8701Z'
                  fill='#292D32'
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className=''>
        <div className='kl-calendar-header'>
          <button className='kl-year-prev' onClick={handlePrevYear}>
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z'
                fill='#292D32'
              />
              <path
                d='M13.2599 16.2799C13.0699 16.2799 12.8799 16.2099 12.7299 16.0599L9.19992 12.5299C8.90992 12.2399 8.90992 11.7599 9.19992 11.4699L12.7299 7.93991C13.0199 7.64991 13.4999 7.64991 13.7899 7.93991C14.0799 8.22991 14.0799 8.70991 13.7899 8.99991L10.7899 11.9999L13.7899 14.9999C14.0799 15.2899 14.0799 15.7699 13.7899 16.0599C13.6499 16.2099 13.4599 16.2799 13.2599 16.2799Z'
                fill='#292D32'
              />
            </svg>
          </button>
          <span className='kl-year-title'>{year}</span>
          <button className='kl-year-next' onClick={handleNextYear}>
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z'
                fill='#292D32'
              />
              <path
                d='M10.7397 16.2799C10.5497 16.2799 10.3597 16.2099 10.2097 16.0599C9.91969 15.7699 9.91969 15.2899 10.2097 14.9999L13.2097 11.9999L10.2097 8.99991C9.91969 8.70991 9.91969 8.22991 10.2097 7.93991C10.4997 7.64991 10.9797 7.64991 11.2697 7.93991L14.7997 11.4699C15.0897 11.7599 15.0897 12.2399 14.7997 12.5299L11.2697 16.0599C11.1197 16.2099 10.9297 16.2799 10.7397 16.2799Z'
                fill='#292D32'
              />
            </svg>
          </button>
        </div>
        <div className='kl-month-container'>
          {months.map((month, index) => (
            <div
              key={index}
              className={
                'kl-content-month' +
                (['Décembre', 'Novembre', 'Octobre'].includes(month) ? ' kl-month-q4' : '')
              }
            >
              <span className={year === currentYear && index === currentMonthIndex ? 'kl-current-month' : ''}>{month}</span>
              <div
                className={
                  (monthlyCounts[index] != 0 && year === currentYear && index === currentMonthIndex ? 'kl-total-docs-month ' : '') +
                  (monthlyCounts[index] == 0 ? 'kl-total-docs-null' : '') + ' ' + 'kl-total-documents kl-total-docs'}
                onClick={() => {
                  if (monthlyCounts[index] > 0) {
                    handleFilterByMonth(index, month);
                  }
                }}
              >
                <span>{monthlyCounts[index]}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <ButtonBars />
      <Filter show={show} onClose={() => setShow(false)} />
    </>
  )
}

export default CalendarFilter
